<template>
<div v-if="$store.state.showBookablesSection" class="bookable-list has-placeholder-sibling">
    <ul class="no-bullet">
        <li v-for="(item, index) in bookables" v-bind:key="item.id">
            <BookableItem :id="index"></BookableItem>
        </li>
    </ul>
</div>
<div v-else>
    <div v-show="$store.state.demoMode" class="bookables-demo-info">
        <b>Demo mode:</b><br/>
        <p>the bookables are not showing because as there is only 1 for this place.</p>
    </div>
</div>
</template>

<script>

import BookableItem from './BookableItem';

export default {
    name: 'BookableItems',
    components: {
        BookableItem
    },
    computed: {
        bookables() {
            return this.$store.state.place.bookables;
        }
    }
};
</script>

<style scoped lang="scss">
    @import "../assets/styles/toolbox.scss";

    .bookables-demo-info {
        display: none;

        @include media(min-width, $bp--app-fixed) {
            display: block;
        }
    }

    .has-placeholder-sibling {
        @include media(min-width, $bp--app-fixed) {
            margin-right: rem(40px);
            flex-grow: 1;
        }
    }

    .bookable-list {
        width: 100%;

        ul {
            list-style: none;
            padding: 0;
        }

        li {
            width: 100%;

            @include media(min-width, $bp--app-fixed) {
                &:last-child {
                    > * {
                        border-bottom: none;
                    }
                }
            }
        }
    }
</style>
